export default __webpack_public_path__ + "static/media/learn_button_settings.1853386d.png";